import DataIsReprocessingBar from 'components/ReusableComponents/DataIsReprocessingBar'
import RestrictedDateWarningCampaigns from 'components/ReusableComponents/RestrictedDateWarning'
import UpdateSelfPhone from 'components/ReusableComponents/UpdateSelfPhone'
import CampaignControls from 'features/ManageCampaigns/CampaignControls'
import CampaignRow from 'features/ManageCampaigns/CampaignRow'
import EditPromoDialog from 'features/ManageCampaigns/EditPromoDialog'
import LimitedInPropertyMessagesWarning from 'features/ManageCampaigns/LimitedInPropertyMessagesWarning'
import OnHoldWarning from 'features/ManageCampaigns/OnHoldWarning'
import { useInternalAdmin } from 'hooks'
import useCampaignCredits from 'hooks/useCampaignCredits'
import useCampaigns from 'hooks/useCampaigns'
import usePlausible from 'hooks/usePlausible'
import { campaignHierarchy } from 'main/campaignHierarchy'
import { DEFAULT_SUBSIDIARY_ID } from 'main/globalVariables'
import { BEs } from 'main/hotelBrandsAndChains'
import moment from 'moment'
import { useEffect, useRef, useState } from 'react'
import ReactPlayer from 'react-player'
import { useDispatch, useSelector } from 'react-redux'
import { useParams } from 'react-router'
import { useToasts } from 'react-toast-notifications'
import campaignApi from 'services/api/campaign'
import hotelApi from 'services/api/hotel'

import { selectCurrentHotelId, selectCurrentHotelName } from '../../accessors/index'
import { getCampaigns } from '../../actions/campains'
import CompareCampaigns from '../../components/ReusableComponents/CompareCampaigns'
import {
  default as ConfirmationDialog,
  default as ConfirmDialog
} from '../../components/ReusableComponents/ConfirmationDialog'
import Header from '../../components/ReusableComponents/HeaderTitles/index'
import CopyIcon from '../../components/ReusableComponents/Icons/CopyIcon'
import LoadingIndicator from '../../components/ReusableComponents/LoadingIndicator'
import NewBadge from '../../components/ReusableComponents/NewBadge/index'
import Tab from '../../components/ReusableComponents/Tabs/index'
import useClickOut from '../../hooks/useClickOut'
import { PMSs } from '../../main/hotelBrandsAndChains'
import lockedCampaigns from '../../main/lockedCampaigns'
import { HotelSelector } from '../Welcome/HotelSwitcher/HotelSelector'
import DripCountIndicator from './DripCountIndicator'
import styles from './ManageCampaigns.module.scss'
import TAdialog from './TripAdvisorURL'
import { ReactComponent as VideoIcon } from './video.svg'
import dialogStyles from './VideoDialog.module.scss'

const importantCampaigns = ['MissingDetailReminder1', 'OptedIn', 'OptInRequest']

function getCommonOTAPromoDetails(campaigns) {
  // business logic

  if (!campaigns) {
    return {}
  }

  // setting the default values

  let promotionCode = null
  let promotionTagline = 'The best rate'
  let minNightsToStay = 1
  let maxDiscountPercentage = 0
  let promoValidityStartDate = null
  let promoValidityEndDate = null
  let hasPromoValidityDate = false

  const OTACampaigns = campaigns
    .filter(c => c.kind === 'Sales')
    .filter(c => campaignHierarchy?.[c.category]?.isOTAcampaign)

  // modifying if all campaigns share the same detail

  if (
    OTACampaigns.some(
      c =>
        OTACampaigns[0].promotionCode === c.promotionCode &&
        OTACampaigns[0].minNightsToStay === c.minNightsToStay &&
        OTACampaigns[0].maxDiscountPercentage === c.maxDiscountPercentage &&
        OTACampaigns[0].promoValidityEndDate === c.promoValidityEndDate &&
        OTACampaigns[0].promoValidityStartDate === c.promoValidityStartDate &&
        OTACampaigns[0].hasPromoValidityDate === c.hasPromoValidityDate
    )
  ) {
    promotionCode = OTACampaigns[0].promotionCode
    promotionTagline = OTACampaigns[0].promotionTagline
    minNightsToStay = OTACampaigns[0].minNightsToStay
    maxDiscountPercentage = OTACampaigns[0].maxDiscountPercentage
    promoValidityStartDate = OTACampaigns[0].promoValidityStartDate
    promoValidityEndDate = OTACampaigns[0].promoValidityEndDate
    hasPromoValidityDate = OTACampaigns[0].hasPromoValidityDate
  }

  return {
    promotionCode,
    promotionTagline,
    minNightsToStay,
    maxDiscountPercentage,
    promoValidityStartDate,
    promoValidityEndDate,
    hasPromoValidityDate
  }
}

function getCommonNonOTAPromoDetails(campaigns) {
  // business logic

  if (!campaigns) {
    return {}
  }

  // setting the default values

  let promotionCode = null
  let promotionTagline = 'The best rate'
  let minNightsToStay = 1
  let maxDiscountPercentage = 0
  let hasPromoValidityDate = false
  let promoValidityStartDate = null
  let promoValidityEndDate = null

  const nonOTACampaigns = campaigns
    .filter(c => c.kind === 'Sales')
    .filter(c => c.category !== 'OptedIn')
    .filter(c => c.category !== 'MissingDetailReminder1')
    .filter(c => c.category !== 'MissingDetailReminder2')
    .filter(c => !campaignHierarchy?.[c.category]?.isOTAcampaign)

  // modifying if all campaigns share the same detail

  if (
    nonOTACampaigns.every(
      c =>
        nonOTACampaigns[0].promotionCode === c.promotionCode &&
        nonOTACampaigns[0].promotionTagline === c.promotionTagline &&
        nonOTACampaigns[0].minNightsToStay === c.minNightsToStay &&
        nonOTACampaigns[0].maxDiscountPercentage === c.maxDiscountPercentage &&
        nonOTACampaigns[0].promoValidityEndDate === c.promoValidityEndDate &&
        nonOTACampaigns[0].promoValidityStartDate === c.promoValidityStartDate &&
        nonOTACampaigns[0].hasPromoValidityDate === c.hasPromoValidityDate
    )
  ) {
    promotionCode = nonOTACampaigns[0].promotionCode
    promotionTagline = nonOTACampaigns[0].promotionTagline
    minNightsToStay = nonOTACampaigns[0].minNightsToStay
    maxDiscountPercentage = nonOTACampaigns[0].maxDiscountPercentage
    promoValidityStartDate = nonOTACampaigns[0].promoValidityStartDate
    promoValidityEndDate = nonOTACampaigns[0].promoValidityEndDate
    hasPromoValidityDate = nonOTACampaigns[0].hasPromoValidityDate
  }

  return {
    promotionCode,
    promotionTagline,
    minNightsToStay,
    maxDiscountPercentage,
    promoValidityStartDate,
    promoValidityEndDate,
    hasPromoValidityDate
  }
}

function getCommonCampaignMedia(campaigns) {
  // business logic

  if (!campaigns) {
    return []
  }

  // setting the default values

  let messageMediaUrls = []

  const salesCampaigns = campaigns.filter(
    c =>
      c.kind === 'Sales' &&
      c.category !== 'OptedIn' &&
      c.category !== 'MissingDetailReminder1' &&
      c.category !== 'MissingDetailReminder2'
  )

  // modifying if all campaigns share the same detail

  if (
    salesCampaigns.every(
      c => c.messageMediaUrls[0] === salesCampaigns[0].messageMediaUrls[0]
    )
  ) {
    messageMediaUrls = salesCampaigns[1].messageMediaUrls
  }

  return messageMediaUrls
}

const CampaignManagement = ({ isDefaultCampaigns }) => {
  const {
    currentHotel,
    currentUser: { phone: userPhone },
    hasTripAdvisorLink,
    subsidiaryBE
  } = useSelector(s => s.login)

  const { type } = useParams()
  const { addToast } = useToasts()

  const isInviteBackDisabled = useSelector(s => s.hotelDetails.inviteBackIsDisabled)

  const isInternalAdmin = useInternalAdmin()

  const currentSubsidiaryId = useSelector(selectCurrentHotelId)
  const currentHotelName = useSelector(selectCurrentHotelName)

  const contentSubsidiaryId = isDefaultCampaigns
    ? DEFAULT_SUBSIDIARY_ID
    : currentSubsidiaryId

  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(getCampaigns(contentSubsidiaryId))
  }, [currentSubsidiaryId, dispatch, contentSubsidiaryId])

  const currentHotelId = useSelector(selectCurrentHotelId)

  const campaigns = useSelector(s => s.campaigns.content[contentSubsidiaryId])

  const alternateReviewLink = useSelector(s => s.campaigns.alternateReviewLink)

  const isLoadingCampaigns = useSelector(s => s.campaigns.isLoadingCampaigns)

  const [isHelpVideoVisible, setHelpVideoVisible] = useState(false)
  const [textStatus, setTextStatus] = useState('waiting')
  const [isTADialogVisible, setTADialogVisible] = useState(hasTripAdvisorLink)

  const [showHotelList, setShowHotelList] = useState()
  const hotelSelectorRef = useRef()
  useClickOut(hotelSelectorRef, () => setShowHotelList(false))

  const [showCompareCampaigns, setShowCompareCampaigns] = useState()
  const [copyContentOrigin, setCopyContentOrigin] = useState()
  const [copyContentDestination, setcopyContentDestination] = useState()
  const { credits: dripCount } = useCampaignCredits()
  const allCampaigns = useCampaigns()

  const restrictedTextingDates = useSelector(s => s.campaigns.restrictedTextingDates)

  const [showUpdatePhoneDialog, setShowUpdatePhoneDialog] = useState(false)

  const isUsingDefaultOperaReports = useSelector(
    s => s.hotelDetails.pms === PMSs.operadefault
  )

  useEffect(() => {
    if (userPhone && showUpdatePhoneDialog) {
      setShowUpdatePhoneDialog(false)
      addToast(`Your phone is added, now you can test the campaigns.`, {
        appearance: 'success',
        autoDismiss: true
      })
    }
  }, [userPhone, showUpdatePhoneDialog, addToast])

  const handleCloseTADialog = async (d, g) => {
    if (!(d && g)) {
      console.warn('wrong link')

      setTADialogVisible(false)
      return
    }

    hotelApi
      .updateAsAdmin(
        { reviewTripAdvisorPage: `https://www.tripadvisor.com/UserReviewEdit-${g}-${d}` },
        currentHotelId
      )
      .then(() => {
        addToast(`Your TripAdvisor url is set!`, {
          appearance: 'info',
          autoDismiss: false
        })
      })
      .finally(() => {
        setTADialogVisible(false)
      })

    setTADialogVisible(false)
  }

  const initiateCopyCampaigns = ({ subsidiaryId, subsidiaryName }) => {
    setShowCompareCampaigns(true)

    if (isDefaultCampaigns) {
      setCopyContentOrigin({
        subsidiaryId: DEFAULT_SUBSIDIARY_ID,
        subsidiaryName: 'Default campains'
      })
      setcopyContentDestination({ subsidiaryId, subsidiaryName })
    } else {
      setCopyContentOrigin({ subsidiaryId, subsidiaryName })
      setcopyContentDestination({
        subsidiaryId: currentSubsidiaryId,
        subsidiaryName: currentHotelName
      })
    }
  }

  const revertCampaignsToDefault = async () => {
    copyCampaigns(
      { subsidiaryId: DEFAULT_SUBSIDIARY_ID, subsidiaryName: 'Default campains' },
      {
        subsidiaryId: currentSubsidiaryId,
        subsidiaryName: currentHotelName
      }
    )
  }

  const copyCampaigns = async (copyContentOrigin, copyContentDestination) => {
    const originId = copyContentOrigin.subsidiaryId
    const destinationId = copyContentDestination.subsidiaryId

    campaignApi
      .copy({ originId, destinationId })
      .then(() => {
        addToast(`Succesfully reverted to suggested content`, {
          appearance: 'success'
        })

        dispatch(getCampaigns(copyContentOrigin.subsidiaryId))
        dispatch(getCampaigns(copyContentDestination.subsidiaryId))
      })
      .catch(() => {
        addToast(`Something went wrong while copying content`, {
          appearance: 'error',
          autoDismiss: false
        })
      })
      .finally(() => {
        setShowCompareCampaigns(false)
      })
  }

  useEffect(() => {
    if (!isDefaultCampaigns) {
      setTADialogVisible(hasTripAdvisorLink === false)
    }
  }, [hasTripAdvisorLink, isDefaultCampaigns])

  const { postEvent, plausibleEvents } = usePlausible()

  const [isEditingPromo, setIsEditingPromo] = useState(false)
  const [promoCategory, setPromoCategory] = useState('nonOTA')

  function showEditPromoDialog(category) {
    setIsEditingPromo(true)
    setPromoCategory(category)
  }

  const commonOTAPromoDetails = getCommonOTAPromoDetails(campaigns)
  const commonNonOTAPromoDetails = getCommonNonOTAPromoDetails(campaigns)
  const commonCampaignMedia = getCommonCampaignMedia(campaigns)

  function applyPromo({
    type,
    promoCode: promotionCode,
    minNights: minNightsToStay,
    maxDiscount: maxDiscountPercentage,
    promoTagline: promotionTagline,
    hasPromoValidityDate,
    promoValidityStartDate,
    promoValidityEndDate
  }) {
    setIsEditingPromo(false)

    if (type === 'OTA') {
      postEvent(plausibleEvents.UpdateOTAPromo)

      campaignApi
        .updateOTApromo({
          promotionCode,
          maxDiscountPercentage,
          promotionTagline,
          minNightsToStay,
          hasPromoValidityDate,
          promoValidityStartDate: promoValidityStartDate
            ? moment(promoValidityStartDate).format('YYYY-MM-DD')
            : null,
          promoValidityEndDate: promoValidityEndDate
            ? moment(promoValidityEndDate).format('YYYY-MM-DD')
            : null
        })
        .then(() => {
          dispatch(getCampaigns(contentSubsidiaryId))
          addToast('Updated OTA discount', { appearance: 'success' })
        })
        .catch(() => {
          addToast('Failed to update the discount', { appearance: 'error' })
        })
    }

    if (type === 'nonOTA') {
      postEvent(plausibleEvents.UpdateDirectPromo)

      campaignApi
        .updateNonOTApromo({
          promotionCode,
          maxDiscountPercentage,
          promotionTagline,
          minNightsToStay,
          hasPromoValidityDate,
          promoValidityStartDate: promoValidityStartDate
            ? moment(promoValidityStartDate).format('YYYY-MM-DD')
            : null,
          promoValidityEndDate: promoValidityEndDate
            ? moment(promoValidityEndDate).format('YYYY-MM-DD')
            : null
        })
        .then(() => {
          dispatch(getCampaigns(contentSubsidiaryId))
          addToast('Updated discount', { appearance: 'success' })
        })
        .catch(() => {
          addToast('Failed to update the discount', { appearance: 'error' })
        })
    }

    if (type === 'optedIn') {
      campaignApi
        .updateOptedInPromo({
          promotionCode,
          maxDiscountPercentage,
          promotionTagline,
          minNightsToStay
        })
        .then(() => {
          dispatch(getCampaigns(contentSubsidiaryId))
          addToast('Updated discount', { appearance: 'success' })
        })
        .catch(() => {
          addToast('Failed to update the discount', { appearance: 'error' })
        })
    }
  }

  const optedInDiscountDetails = campaigns?.find(r => r.category === 'OptedIn')

  return (
    <>
      {showUpdatePhoneDialog && (
        <ConfirmationDialog
          hasConfirmButton={false}
          title="Add your phone number to test the campaigns"
          handleHideDialog={() => setShowUpdatePhoneDialog(false)}
        >
          <UpdateSelfPhone />
        </ConfirmationDialog>
      )}
      {showCompareCampaigns && (
        <CompareCampaigns
          destinationSubsidiaryId={copyContentOrigin.subsidiaryId}
          destinationSubsidiaryName={copyContentOrigin.subsidiaryName}
          originSubsidiaryId={copyContentDestination.subsidiaryId}
          originSubsidiaryName={copyContentDestination.subsidiaryName}
          handleClose={() => setShowCompareCampaigns(false)}
          handleConfirm={() => copyCampaigns(copyContentOrigin, copyContentDestination)}
        />
      )}
      <>
        <Header
          title={isDefaultCampaigns ? 'Default Campaigns' : 'Automated messages'}
          width={1000}
          isFixed={true}
        />
        {isTADialogVisible && !isDefaultCampaigns && (
          <TAdialog
            subsidiaryName={currentHotel}
            handleHideDialog={handleCloseTADialog}
          />
        )}
        <div className={styles.titleGroup}>
          {isEditingPromo && promoCategory === 'OTA' && (
            <EditPromoDialog
              title="Apply OTA discount"
              handleSave={details => applyPromo({ type: 'OTA', ...details })}
              handleCloseDialog={() => setIsEditingPromo(false)}
              {...commonOTAPromoDetails}
            />
          )}
          {isEditingPromo && promoCategory === 'nonOTA' && (
            <EditPromoDialog
              title="Apply discount"
              handleSave={details => applyPromo({ type: 'nonOTA', ...details })}
              handleCloseDialog={() => setIsEditingPromo(false)}
              {...commonNonOTAPromoDetails}
            />
          )}
          {isEditingPromo && promoCategory === 'optedIn' && (
            <EditPromoDialog
              title="Apply opt-in discount"
              handleSave={details => applyPromo({ type: 'optedIn', ...details })}
              handleCloseDialog={() => setIsEditingPromo(false)}
              {...optedInDiscountDetails}
            />
          )}
          {textStatus === 'sending' && (
            <UploadStatusDialog>
              <h3>Sending test message</h3>
              <p>This will take just a second</p>
            </UploadStatusDialog>
          )}
          {textStatus === 'errored' && (
            <ConfirmDialog
              title={`Something went wrong`}
              hasNegativeMessage={false}
              positiveMessage="OK"
              className={styles.campaignDialog}
              handleConfirm={() => setTextStatus('waiting')}
              handleHideDialog={() => setTextStatus('waiting')}
            >
              <p>
                Something went wrong while sending test message. Please try again later.
              </p>
            </ConfirmDialog>
          )}
        </div>
        <div className={styles.wrapper}>
          <Tab.Parent>
            <Tab
              to={`/${isDefaultCampaigns ? 'defaultCampaigns' : 'manageCampaigns'}/sales`}
            >
              Invite messages
            </Tab>
            <Tab
              to={`/${
                isDefaultCampaigns ? 'defaultCampaigns' : 'manageCampaigns'
              }/service`}
            >
              In-property messages
            </Tab>
            {!isDefaultCampaigns && (
              <Tab to="/custom-campaigns">
                Drip campaigns <NewBadge className={styles.newBadge} />
              </Tab>
            )}
            <div className={styles.sideControls}>
              <div className={styles.copyHolder}>
                <button onClick={() => setShowHotelList(true)}>
                  <CopyIcon /> Copy {isDefaultCampaigns ? 'to' : 'from'}...
                </button>
                {showHotelList && (
                  <div className={styles.hotelSelector} ref={hotelSelectorRef}>
                    <HotelSelector handleSelect={initiateCopyCampaigns} />
                  </div>
                )}
              </div>
            </div>
          </Tab.Parent>
          {dripCount > 0 && (
            <DripCountIndicator
              dripCount={dripCount}
              isDefaultCampaigns={isDefaultCampaigns}
            />
          )}
          <DataIsReprocessingBar />
          {restrictedTextingDates?.length > 0 && (
            <RestrictedDateWarningCampaigns
              restrictedTextingDates={restrictedTextingDates}
            />
          )}
          {isUsingDefaultOperaReports && type === 'service' && (
            <LimitedInPropertyMessagesWarning />
          )}
          {!isLoadingCampaigns && type === 'sales' && !isDefaultCampaigns && (
            <>
              <CampaignControls
                isDefaultCampaigns={isDefaultCampaigns}
                showEditPromoDialog={showEditPromoDialog}
                hasOTADiscount={commonOTAPromoDetails.promotionCode}
                OTADiscount={commonOTAPromoDetails.maxDiscountPercentage}
                hasNonOTADiscount={commonNonOTAPromoDetails.promotionCode}
                nonOTADiscount={commonNonOTAPromoDetails.maxDiscountPercentage}
                optedInDiscount={
                  campaigns?.find(r => r.category === 'OptedIn').maxDiscountPercentage
                }
                hasOptedInDiscount={
                  campaigns?.find(r => r.category === 'OptedIn').promotionCode
                }
                commonCampaignMedia={commonCampaignMedia[0]}
                contentSubsidiaryId={contentSubsidiaryId}
                revertCampaignsToDefault={revertCampaignsToDefault}
              />
              <p className={styles.cardsTitle}>Advanced settings</p>
            </>
          )}
          {!isLoadingCampaigns && isInviteBackDisabled && <OnHoldWarning />}
          <div className={styles.cardsWrapper}>
            {isLoadingCampaigns && <LoadingIndicator />}
            {!isLoadingCampaigns &&
              campaigns &&
              campaigns
                .filter(r => !r.category.includes('ConsentRequest'))
                .filter(c =>
                  type === 'custom'
                    ? c.category === 'Custom'
                    : type.match(new RegExp(c.kind, 'i')) && c.category !== 'Custom'
                )
                .filter(c => (isInternalAdmin ? true : c.category !== 'BookingUpdated'))
                .filter(c => (isInternalAdmin ? true : c.category !== 'OptInRequest'))
                .filter(c =>
                  isInternalAdmin ? true : c.category !== 'AlreadySubscribed'
                )
                .filter(c => !campaignHierarchy?.[c.category]?.isOTAcampaign)
                .filter(c => c.category !== 'MissingDetailReminder1')
                .filter(c => c.category !== 'MissingDetailReminder2')
                .filter(c => c.category !== 'OptedIn')
                .filter(c => c.category !== 'OptInRequest')
                .filter(c => c.category !== 'ServiceStartForSecondaryGuest')
                .filter(c => c.category !== 'ServiceRestart')
                .filter(c => c.category !== 'DirectAccess')
                .filter(c => c.category !== 'ReviewReminder1')
                .filter(c => c.category !== 'ReviewReminder2')
                .sort(c => (c.category === 'MissingDetailReminder1' ? -1 : 1))
                .sort(c => (c.category === 'OptInRequest' ? -1 : 1))
                .map(c => (
                  <>
                    <CampaignRow
                      {...c}
                      campaigns={allCampaigns[c.category]}
                      OTACampaign={campaigns.find(
                        d => d.category === campaignHierarchy?.[c.category]?.OTAVariant
                      )}
                      alternateReviewLink={alternateReviewLink}
                      regularCampaign={c}
                      type={type}
                      isDefaultCampaigns={isDefaultCampaigns}
                      key={c.category}
                      isLocked={
                        lockedCampaigns.includes(c.category) || isDefaultCampaigns
                      }
                      isImportant={importantCampaigns.includes(c.category)}
                    />
                  </>
                ))}
          </div>
        </div>
        {subsidiaryBE === BEs.synxis && (
          <button
            className={styles.synxisHelpButton}
            onClick={() => setHelpVideoVisible(true)}
          >
            <VideoIcon />
            See how to create promo code on SynXis
          </button>
        )}
        <VideoDialog
          isVisible={isHelpVideoVisible}
          handleCloseClick={() => setHelpVideoVisible(false)}
        />
      </>
    </>
  )
}

const VideoDialog = ({ isVisible, handleCloseClick }) =>
  isVisible ? (
    <div className={dialogStyles.holder}>
      <div className={dialogStyles.dialog}>
        <button className={dialogStyles.close} onClick={handleCloseClick}></button>
        <ReactPlayer url="https://www.youtube.com/watch?v=OCKeFWINrlU" playing />
      </div>
      <div className={dialogStyles.overlay} onClick={handleCloseClick}></div>
    </div>
  ) : null

export default CampaignManagement

const UploadStatusDialog = ({ children }) => {
  return (
    <>
      <div className={styles.statusDialog}>{children}</div>
      <div className={styles.statusDialogOverlay}></div>
    </>
  )
}
